import { render, staticRenderFns } from "./Wp_jd_home.vue?vue&type=template&id=7c690bc2&scoped=true&"
import script from "./Wp_jd_home.vue?vue&type=script&lang=js&"
export * from "./Wp_jd_home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c690bc2",
  null
  
)

export default component.exports